// frontend/src/components/Session/SessionTimeoutModal.tsx
import React from 'react';
import { Modal, Button, Typography } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useSessionActivity } from '../../contexts/SessionActivityContext';

const { Text } = Typography;

function fmt(total: number): string {
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function SessionTimeoutModal() {
  const { warningOpen, secondsLeft, extend } = useSessionActivity();
  return (
    <Modal
      open={warningOpen}
      centered
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      title={<span><ClockCircleOutlined style={{ marginRight: 8 }} />Still there?</span>}
    >
      <Text>You'll be signed out for inactivity in </Text>
      <Text strong>{fmt(secondsLeft)}</Text>
      <Text>. Your work will be saved.</Text>
      <div style={{ marginTop: 20, textAlign: 'right' }}>
        <Button type="primary" onClick={extend}>Stay signed in</Button>
      </div>
    </Modal>
  );
}
